import React, { useContext, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { baseURL } from "../../../../../config";
import { path } from "../../../../constants/apiPath";
// import routeConstant from "../../../../routes/utils/routeConstant";
import axios from "axios";
import { IsLogin } from "../../../../../utils";
import { StoreContext } from "../../../../store";
import useForm from "../../../../common/hooks/useForm";
import routeConstant from "../../../../../route/compoent/routeConstant";
import "../../index.css";

function ResetPassword() {
  const navigation = useNavigate();
  const context = useContext(StoreContext);
  const location = useLocation();
  const password = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const confirmpassword = useForm();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  //   const [emailId, setEmailId] = useState("");

  useEffect(() => {
    validateLink();
  }, []);

  const validateLink = () => {
    context.setBackDropOpen(true);
    const link = location.pathname.split("/resetPassword/")[1];
    const url = `${baseURL}${path.VALIDATELINK}?guid=${link}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.Is_Success) {
          NotificationManager.success(res.data.Message, "", 3000);
          //   setEmailId(res.data.data);
          context.setBackDropOpen(false);
        } else {
          NotificationManager.error(res.data.Message, "", 3000);
          // setTimeout(() => {
          //   context.setBackDropOpen(false);
          //   if (IsLogin()) {
          //     navigation(routeConstant.DASHBOARD);
          //   } else {
          //     navigation(routeConstant.LOGIN);
          //   }
          // }, 3100);
        }
      })
      .catch((err) => {
        if (err.response) {
                      context.setBackDropOpen(false);

        //   NotificationManager.error(err.response.data.Message, "", 3000);
        //   setTimeout(() => {
        //     context.setBackDropOpen(false);
        //     if (IsLogin()) {
        //       navigation(routeConstant.DASHBOARD);
        //     } else {
        //       navigation(routeConstant.LOGIN);
        //     }
        //   }, 3100);
        // } else if (err.request) {
        // } else if (err.message) {
        // } else {
        //   NotificationManager.error("Something went wrong!", "", 3000);
        //   // setTimeout(() => {
        //   //   context.setBackDropOpen(false);
        //   //   if (IsLogin()) {
        //   //     navigation(routeConstant.DASHBOARD);
        //   //   } else {
        //   //     navigation(routeConstant.LOGIN);
        //   //   }
        //   // }, 3100);
        }
      }
      );
  };

  const onReset = () => {
    if (password.value && confirmpassword.value) {
      context.setBackDropOpen(true);
      const link = location.pathname.split("/resetPassword/")[1];
      const url = `${baseURL}${path.RESETPASSWORD}?guid=${link}&currentPassword=${password.value}&confirmPassword=${confirmpassword.value}`;
      axios
        .post(url)
        .then((res) => {
          if (res.data.Is_Success) {
            NotificationManager.success(res.data.Message, "", 3000);
            setTimeout(() => {
              context.setBackDropOpen(false);
              if (IsLogin()) {
                navigation(routeConstant.DASHBOARD);
              } else {
                navigation(routeConstant.LOGIN);
              }
            }, 3100);
          } else {
            context.setBackDropOpen(false);
            NotificationManager.error(res.data.Message, "", 3000);
          }
        })
        .catch((err) => {
          context.setBackDropOpen(false);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      if (!password.value) {
        password.setError(true);
        password.setErrorMsg("New Password required.");
      }
      if (!confirmpassword.value) {
        confirmpassword.setError(true);
        confirmpassword.setErrorMsg("Confirm Password required.");
      }
    }
  };

  return (
    <div className="_resetComponent">
      
      <div className="_resetComponentformDiv">
        <h3 className="mb-4">FORGOT PASSWORD!</h3>
        <div
          className={
            password.error
              ? "_inputBox-Parent _error my-3"
              : "_inputBox-Parent my-3"
          }
        >
          <div className="_inputBox _inputPass">
            <input
              className="form-control"
              placeholder="New Password"
              type={showPassword ? "text" : "password"}
              onFocus={password.onFocus}
              value={password.value}
              onChange={password.onChange}
            />
            <LockIcon />
            {showPassword ? (
              <VisibilityOffIcon
                className="_showPassword"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            ) : (
              <VisibilityIcon
                className="_showPassword"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            )}
          </div>
          {password.error ? <div>{password.errorMsg}</div> : null}
        </div>
        <div
          className={
            confirmpassword.error
              ? "_inputBox-Parent _error my-3"
              : "_inputBox-Parent my-3"
          }
        >
          <div className="_inputBox _inputPass">
            <input
              className="form-control"
              placeholder="Confirm Password"
              type={showConfirmPassword ? "text" : "password"}
              onFocus={confirmpassword.onFocus}
              value={confirmpassword.value}
              onChange={confirmpassword.onChange}
            />
            <LockIcon />
            {showConfirmPassword ? (
              <VisibilityOffIcon
                className="_showPassword"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              />
            ) : (
              <VisibilityIcon
                className="_showPassword"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              />
            )}
          </div>
          {confirmpassword.error ? <div>{confirmpassword.errorMsg}</div> : null}
        </div>
        <div className="_rememberMe my-4">
          <div className="_rememberMeLeft form-check mb-0">
            {/* <FormControlLabel
              label="Remember Me"
              control={
                <Checkbox
                  size="small"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
              }
            /> */}
          </div>
          
        </div>
        <div className="_resetButton my-4">
          <button onClick={onReset}>RESET</button>
        </div>
        <div className="_rememberMeRight _returntologin">
            <span onClick={() => navigation(routeConstant.LOGIN)}>Return to Login</span>
          </div>
        {/* <div className="_goToSignUp d-lg-block d-none my-4">
          <label>Dont Have An Account?</label>
          <div>
            <span
              onClick={() => {
                navigation(routeConstant.SIGNUP);
                // setValue(1);
              }}
            >
              Request Access
            </span>
          </div>
        </div>
        <div className="_OrHr my-4">
          <hr />
          <span>OR</span>
        </div>
        <div className="_loginTrackOrder">
          <button onClick={() => {}}>TRACK ORDER AS GUEST</button>
        </div> */}
      </div>
    </div>
  );
}

export default ResetPassword;
